export default [
    {
        "fileId": "caf4e4bf-1312-4a48-a5e1-90a44b4004f8",
        "name": "Man Struck By Lightning Faces Battery Charge",
        "mimeType": "image/webp",
        "size": 1475044050,
        "createdDate": "2003-11-17T17:51:50",
        "createdBy": "Olivia Sanchez <Olivia.Sanchez@telus.net>"
      },
      {
        "fileId": "35859795-0841-48e4-928b-a89d71508d19",
        "name": "Most Earthquake Damage is Caused by Shaking",
        "mimeType": "image/png",
        "size": 751610543,
        "createdDate": "2012-12-15T05:10:15",
        "createdBy": "Lorrie Robinson <Lorrie.Robinson@live.com>"
      },
      {
        "fileId": "5cbb246e-8b67-45e9-8f18-6347f9d7147a",
        "name": "Teacher Strikes Idle Kids",
        "mimeType": "image/jpeg",
        "size": 682989124,
        "createdDate": "2010-04-12T21:47:35",
        "createdBy": "Stephen Pitt <Stephen.Pitt@rogers.ca>"
      }
  ];